import Ajax from '@/api/ajax'

export const security = (data) => Ajax.request('/frameworks/systems/user/security', 'get', data, { showLoading: false })

// 上传图片
export const uploadImg = (param) => Ajax.request(`/frameworks/photos/upload`, 'post', param, { showLoading: true })

// home
export const homeList = (param) => Ajax.request(`/business/commodity/home/list`, 'post', param, { showLoading: true })

// 可预约服务
export const getMakeAnAppointmentTime = (param) => Ajax.request(`/business/commodity/home/detail`, 'post', param, { showLoading: true })

// 我的预约
export const appointmentList = (param) => Ajax.request(`/business/appointment/list`, 'get', '', { showLoading: true })
// 预约确定 /business/appointment/create
export const makeAnAppointmentSubmit = (param) => Ajax.request(`/business/appointment/create`, 'post', param, { showLoading: true })
// 预约取消
export const makeAnAppointmentCancel = (param) => Ajax.request(`/business/appointment/cancel`, 'post', param, { showLoading: true })
// 预约订单
export const makeAnAppointmentOrder = (param) => Ajax.request(`/business/appointment/listAll`, 'post', param, { showLoading: true })

// 预约详情 /externalAppointmentDetail
export const getMakeAnAppointmentDetails = (param) => Ajax.request(`/business/appointment/externalAppointmentDetail/${param}`, 'get', '', { showLoading: true })

export const serviceDateList = (param) => Ajax.request(`/business/commodity/home/serviceDateList/${param}`, 'get', '', { showLoading: true })

export const commoditySpuDetail = (param) => Ajax.request(`/business/commodity/home/commoditDetail/${param}`, 'get', '', { showLoading: true })

// 服务扩展信息
export const commodityConfigIndo = (data) => Ajax.request('/business/commodity/home/commodityConfitDetail', 'post', data, { showLoading: true })

// 候补
export const beAnAlternate = (data) => Ajax.request('/business/appointment/candidate/create', 'post', data, { showLoading: true })

// 360登录
export const apiQihooLogin = (data) => Ajax.request('/business/login/qihoo/login', 'post', data, { showLoading: true })
// 候补列表
export const candidate = (data) => Ajax.request('/business/appointment/candidate/list', 'post', data, { showLoading: true })

export const candidateStatus = (data) => Ajax.request(`/business/commodity/home/serviceDateStatusList/${data}`, 'get', '', { showLoading: false })

// /business/commodity/home/serviceDateStatusList/{primaryKey
